<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 18 18"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M7.96 0h.086c.431 0 .818.063 1.14.179.16.058.305.126.434.236.128.11.257.287.257.505 0 .22-.129.402-.257.512-.129.11-.274.178-.435.236-.163.06-.344.105-.54.135l.362.728C12.946 3.013 16 6.287 16 10.241 16 14.523 12.412 18 8 18c-4.414 0-8-3.476-8-7.76 0-3.952 3.053-7.226 6.993-7.709l.362-.728a2.794 2.794 0 0 1-.54-.135 1.353 1.353 0 0 1-.435-.236.69.69 0 0 1-.25-.512c0-.218.122-.395.25-.505.129-.11.274-.178.435-.236C7.135.063 7.529 0 7.96 0zM8 4.628c-3.187 0-5.774 2.518-5.774 5.612 0 3.094 2.588 5.606 5.774 5.606 3.185 0 5.781-2.512 5.781-5.606a.415.415 0 0 0-.421-.409H8.42V5.037A.415.415 0 0 0 8 4.627z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
